import { useContext, useEffect, useState } from 'react'
import ConfigurationApiContext, { TEAM_ROLE_LABELS } from 'src/provider/API/v2/call-service/configuration'

export interface SidebarUser {
    name: string
    role: string
    initials?: string
}

const FALLBACK_USER: SidebarUser = { name: '', role: '' }

const getInitials = (fullName?: string) =>
    fullName
        ?.split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('') || undefined

export const useSidebarUser = (): SidebarUser => {
    const { adminProfile, getAdminProfile } = useContext(ConfigurationApiContext)
    const [user, setUser] = useState<SidebarUser>(FALLBACK_USER)

    useEffect(() => {
        getAdminProfile()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (adminProfile) {
            setUser({
                name: adminProfile.fullName,
                role: TEAM_ROLE_LABELS[adminProfile.role] ?? adminProfile.role,
                initials: getInitials(adminProfile.fullName),
            })
        }
    }, [adminProfile])

    return user
}